export default "__VITE_ASSET__iqsy1mpy__"